import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Typography, Box } from '@mui/material';
import React from 'react';


export default function ReleaseNotesSection(props) {
    const { name, data } = props

    return(
        <Box sx={{marginBottom: '20px'}}>
            <Typography variant="h6" component="h6">
                {name}
            </Typography>
            {
                data.map(item => (
                    <AccordionDetails>
                        <Typography variant="body1" component="body1">
                            {item[Object.keys(item)[0]]}
                        </Typography>

                        <Typography variant="body1" sx={{marginLeft: '10px', opacity:'0.5'}}>
                            {item[Object.keys(item)[1]]}
                        </Typography>
                        {
                            item[Object.keys(item)[2]]
                            ?
                            <img src={item[Object.keys(item)[2]]} style={{maxWidth:"600px", margin: '20px'}}/>
                            :
                            <></>
                        }
                        
                    </AccordionDetails>
                ))
            }
        </Box>
    )
}